import { createSlice } from '@reduxjs/toolkit';

import { NotificationType } from '../utils/enums';

const initialState = {
  notification: {}
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action) => {
      state.notification = { msg: action.payload, status: NotificationType.SUCCESS };
    },
    addErrorNotification: (state, action) => {
      state.notification = { msg: action.payload, status: NotificationType.ERROR };
    },
    addWarningNotification: (state, action) => {
      state.notification = { msg: action.payload, status: NotificationType.WARNING };
    }
  }
});

export const { addNotification, addErrorNotification, addWarningNotification } = notificationsSlice.actions;

export default notificationsSlice.reducer;
